var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-loading',{staticClass:"loading",attrs:{"type":"spinner","color":"#fe5900","vertical":true,"size":"32px"}},[_vm._v("努力加载中 ")])}
var staticRenderFns = []

export { render, staticRenderFns }